<template>
  <div v-resize="setContentHeight" class="search-result">
    <v-toolbar dark color="primary" class="pr-1">
      <v-btn icon @click="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>Search Results</v-toolbar-title>
    </v-toolbar>

    <div v-if="searchResponse">
      <v-card
        tile
        class="px-2 py-2 mb-1 text-small font-weight-bold primary--text"
        style="border-bottom-left-radius: 3px; border-bottom-right-radius: 3px"
      >
        <div v-if="searchResponse.found">
          <v-row no-gutters>
            <v-col class="col-1">
              <v-icon class="icon-small">mdi-information</v-icon>
            </v-col>
            <v-col>1 result found.</v-col>
          </v-row>
        </div>
        <div v-else class="red--text">
          <v-row no-gutters>
            <v-col class="col-1">
              <v-icon color="red" class="icon-small">mdi-alert</v-icon>
            </v-col>
            <v-col>
              No matching results found. Other suggested slot below:
            </v-col>
          </v-row>
        </div>
      </v-card>

      <div ref="searchResultsScrollable" class="scrollable">
        <v-card tile class="mb-1" @click="showBookingDetails">
          <v-row no-gutters>
            <v-col class="col-3 flex-center-left-container">
              <v-img
                class="ma-1x"
                :src="`${branchImagePath}${searchResponse.visitCapacity.branchImageUrls[0]}`"
                aspect-ratio="1"
                max-height="100"
                max-width="100"
              />
            </v-col>
            <v-col class="col-9 pl-4 pt-5x" style="padding-top: 16px">
              <v-row no-gutters class="pb-2">
                <v-col class="text-title-black text-truncate">{{
                  searchResponse.visitCapacity.branchName
                }}</v-col>
              </v-row>
              <v-row no-gutters class="text-small">
                <v-col class="col-12">
                  <span class="pr-3">
                    <v-icon class="icon-smaller">mdi-clock-outline</v-icon>
                    {{
                      formatPeriod(
                        searchResponse.visitCapacity.startTime,
                        searchResponse.visitCapacity.endTime
                      )
                    }}
                  </span>
                  <span>
                    <v-icon class="icon-small" style="padding-right: 5px"
                      >mdi-counter</v-icon
                    >
                    {{
                      formatAvailability(
                        searchResponse.visitCapacity.availableVisitCapacity,
                        searchResponse.visitCapacity.visitCapacityOfTheTimeSlot
                      )
                    }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import formatters from "@/helpers/formatters";

export default {  
  name: "VisitBookingSearchResults",
  data: () => ({
    searchResponse: null,
  }),
  computed: {
    ...mapState(["visitBookingSearchResult"]),
  },
  methods: {
    showBookingDetails() {
      this.$router.push({
        name: "VisitBookingDetails",
      });
    },
    formatPeriod(fromDateString, toDateString) {
      return formatters.formatPeriod(fromDateString, toDateString);
    },
    formatAvailability(availableSeatsCount, totalSeatCount) {
      return `${availableSeatsCount}/${totalSeatCount}`;
    },
    setContentHeight() {
      if (this.$refs.searchResultsScrollable) {
        const heights = this.heights();
        const contentHeight =
          heights.screen - heights.toolbar - heights.headerbar - heights.noticeBarHeight;

        this.$refs.searchResultsScrollable.style.height = contentHeight + "px";
      }
    },
  },
  activated() {
    this.searchResponse = this.visitBookingSearchResult;

    this.$nextTick(() => this.setContentHeight());
  },
};
</script>